module.exports = __webpack_public_path__ + "c3e81a320e0f4bdf0a0590f36424c6ee.svg";